import { createReducer } from '@reduxjs/toolkit'
import { DeeplinkState, DeeplinkFlowType } from '@/deeplink/types'
import { DEEPLINK_FLOWS } from '@/deeplink/registry'
import { captureDeeplink, clearFlow } from './action'

const initialState: DeeplinkState = {
  flows: {},
}

const deeplinkReducer = createReducer(initialState, builder => {
  builder.addCase(captureDeeplink, (state, { payload: params }) => {
    const po = params.po as DeeplinkFlowType | undefined
    if (!po) return

    const flowConfig = DEEPLINK_FLOWS[po]
    if (!flowConfig) return

    if (state.flows[po]) return

    state.flows[po] = {
      type: po,
      params,
      status: 'pending',
    }
  })

  builder.addCase(clearFlow, (state, { payload: flowType }) => {
    delete state.flows[flowType]
  })
})

export default deeplinkReducer
